import { addNamespace } from '@Utils/actions';
import { createAction } from '@reduxjs/toolkit';

import { ImagePath } from '@Types/images.types';

export const getImagePath = createAction<string>(addNamespace('imagePath/get'));
export const getImagePathResolved = createAction<ImagePath>(
	addNamespace('imagePath/get/resolved'),
);
